module.exports = __webpack_public_path__ + "img/ethnic.3a4c5ced.png";